import { css, type Theme } from "@emotion/react";

import { dimensions } from "@styles";

export const columnsContainer = css`
  flex: 1;

  && {
    @media (min-width: ${dimensions.tablet}) {
      margin: 0;
    }
  }
`;

export const leftColumn = (theme: Theme) => css`
  background: ${theme.primary.backgroundBox};
  border-right: 1px solid ${theme.system.borderBase};
  padding: 2rem 1rem;

  @media (min-width: ${dimensions.tablet}) {
    padding: 1rem;
  }
`;

export const section = css`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 30.75rem;
  height: 100%;
  justify-content: center;
  margin: auto;
`;

export const rightColumn = css`
  padding: 0 1rem;
  margin: auto;
`;

export const layoutContainer = css`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const fsLogo = css`
  max-width: 14.5rem;
  margin-bottom: 1.25rem;
`;

export const wvLogo = css`
  max-width: 6.625rem;
  margin-bottom: 2.875rem;
`;
